/**
 * S3 (5 Kas): ana sayfa akışında görülen kartlar (yalnız bu tarayıcı, izleyiciye bağlı). Kart
 * kimliği → ilk görülme zamanı; 7 gün sonra silinir, sunucuya gitmez. Depolama kapalıysa boş döner.
 */
const KEY_PREFIX = 'tenis.feed.seen.';
export const FEED_SEEN_TTL_MS = 7 * 24 * 60 * 60 * 1000;
const MAX_ENTRIES = 300;

const key = (viewerId: string) => `${KEY_PREFIX}${viewerId}`;

const prune = (seen: Record<string, number>, now: number) =>
  Object.fromEntries(
    Object.entries(seen)
      .filter(
        ([id, at]) => !!id && typeof at === 'number' && at <= now && now - at <= FEED_SEEN_TTL_MS,
      )
      .sort((a, b) => b[1] - a[1])
      .slice(0, MAX_ENTRIES),
  );

export function readFeedSeen(
  viewerId: string,
  storage?: Pick<Storage, 'getItem'>,
  now = Date.now(),
): Record<string, number> {
  try {
    const raw = (storage || window.localStorage).getItem(key(viewerId));
    const value = raw ? JSON.parse(raw) : null;
    return value && typeof value === 'object' && !Array.isArray(value) ? prune(value, now) : {};
  } catch {
    return {};
  }
}

/** Kartları görüldü işaretler; daha önce görülenin ilk zamanı korunur. */
export function markFeedSeen(
  viewerId: string,
  ids: string[],
  storage?: Pick<Storage, 'getItem' | 'setItem'>,
  now = Date.now(),
): void {
  try {
    const store = storage || window.localStorage;
    const seen = readFeedSeen(viewerId, store, now);
    ids.forEach(id => {
      if (id && !seen[id]) seen[id] = now;
    });
    store.setItem(key(viewerId), JSON.stringify(prune(seen, now)));
  } catch {
    // Depolama kapalı: sıralama görülme bilgisi olmadan çalışır.
  }
}
